type UnknownRecord = Record<string, unknown>;

export interface ApiErrorShape {
  code?: string;
  message?: string;
}

function isRecord(v: unknown): v is UnknownRecord {
  return typeof v === "object" && v !== null;
}

function firstText(value: unknown): string | undefined {
  return typeof value === "string" && value.trim().length > 0
    ? value.trim()
    : undefined;
}

function pickMessage(value: unknown): string | undefined {
  if (typeof value === "string") return firstText(value);
  if (Array.isArray(value)) {
    for (const entry of value) {
      const message = pickMessage(entry);
      if (message) return message;
    }
    return undefined;
  }
  if (!isRecord(value)) return undefined;
  const message =
    firstText(value.message) ?? firstText(value.msg) ?? firstText(value.error);
  if (message) return message;
  return pickMessage(value.detail);
}

export function parseErrorPayload(data: unknown): ApiErrorShape {
  if (!isRecord(data)) return {};
  const envelope = isRecord(data.error) ? data.error : data;
  const code = firstText(envelope.code) ?? firstText(data.code);
  const message = pickMessage(envelope);
  const result: ApiErrorShape = {};
  if (code !== undefined) result.code = code;
  if (message !== undefined) result.message = message;
  return result;
}
